import { Badge } from "@/shared/foundation/primitives";

/** Marks a rule's saved action as switched off. */
export function PausedBadge() {
  return <Badge variant="warning">Paused</Badge>;
}
